
import SwapIcon from "../../../components/icons/SwapIcon"
import { useRunAfterUpdate } from "../../../core/hooks/useRunAfterUpdate"
import { onInputValueChangeUtil } from "../../../core/utils/useInputValueChange"
import { Input } from "../../../styles/newStyles/Register.styled"
import { Text, useMainContext, useWindowSize } from "../../Dashboard"
import { useSwap } from "../core/useSwap"
import CryptoCoinSelect from "./CryptoCoinSelect"
import SwapInvoice from "./SwapInvoice"

const SwapMain = () => {
    const { width } = useWindowSize()
    const { main: { lang } } = useMainContext()

    const {
        payload,
        updatePayload,
        getInvoice,
        confirmSwap,
        isInvoiceLoading,
        isSwapLoading,
        balance,
        invoiceData
    } = useSwap()

    const afterUpdate = useRunAfterUpdate()

    const onChange = (e, field) => {
        let value = onInputValueChangeUtil(e, afterUpdate)
        // Remove leading zero if user starts typing (but allow "0." for decimals)
        if (field === "amount") {
            if (value === ".") value = "0";
            // prevent "00", "000", etc BEFORE decimal
            if (/^0\d+/.test(value) && !value.startsWith("0.")) {
                value = "0."
            }
        }

        updatePayload(field, value)
    }


    const actionHandler = () => {
        getInvoice()
    }

    return (
        <div
            className={
                "w-full  relative rounded-xl mx-auto"
            }
        >
            {/* Form */}
            <div
                className={"grid grid-cols-1 md:grid-cols-7 text-sm gap-3 max-w-screen-md relative z-[20] mx-auto"}
            >
                {/* From Currency */}
                <div className={"flex flex-col gap-2 w-full md:col-span-3 bg-[#1E1533] rounded-lg p-3"}>
                    <div className="flex items-center justify-between gap-5">
                        <Text tid={"from"} className="text-lg" />
                        <CryptoCoinSelect
                            className={"!bg-transparent max-w-max"}
                            type={'buy'}
                            coin={payload.fromCurrency}
                            onChange={(val) => updatePayload("fromCurrency", val)}
                        />
                    </div>
                    <div
                        className={
                            "w-full h-[48px] rounded-xl  flex items-center justify-between"
                        }
                    >
                        <Input
                            placeholder={lang === "fa" ? "مقدار مورد نظر برای تبدیل" : "Enter amount to swap"}
                            className={"p-2"}
                            autoFocus
                            value={payload.amount}
                            onChange={(e) => onChange(e, "amount")}
                        />
                    </div>
                    <div className="flex justify-between items-center">
                        {/* Balance */}
                        <span className="inline">
                            <Text tid={"balance"} className="inline" />
                            <span>
                                {" = "}
                            </span>
                            <span>
                                {balance ?? "-"}
                            </span>
                        </span>
                    </div>
                </div>

                {/* Divider */}
                <div className="flex items-center justify-center gap-4 my-5 md:col-span-1">
                    <SwapIcon color="#FC6432" size={26} />
                </div>

                {/* To Currency */}
                <div className={"flex flex-col gap-2 w-full md:col-span-3 bg-[#1E1533] rounded-lg p-3"}>
                    <div className="flex items-center justify-between gap-5">
                        <Text tid={"to"} className="text-lg" />
                        <CryptoCoinSelect
                            className={"!bg-transparent max-w-max"}
                            type={'buy'}
                            coin={payload.toCurrency}
                            onChange={(val) => updatePayload("toCurrency", val)}
                        />
                    </div>
                    <div
                        className={
                            "w-full h-[48px] rounded-xl  flex items-center justify-between"
                        }
                    >
                        <Input
                            className={`text-2xl ${invoiceData?.toAmountAfterWage > 0 ? "border-mainColor transition-all duration-[0.6s]" : ""}`}
                            disabled
                            value={invoiceData?.toAmountAfterWage || 0}
                        />
                    </div>
                </div>
            </div>
            {/* Invoice Preview directly under form */}
            <div className="mt-6 max-w-screen-md mx-auto">
                <SwapInvoice
                    data={
                        invoiceData || {
                            amount: 0,
                            priceUnitFrom: 0,
                            priceUnitTo: 0,
                            toAmount: 0,
                            wage: 0,
                            toAmountAfterWage: 0,
                        }
                    }
                    fromCurrency={payload.fromCurrency?.id || ''}
                    toCurrency={payload.toCurrency?.id || ''}
                    onContinue={confirmSwap}
                    loading={isSwapLoading || isInvoiceLoading}
                />
            </div>

        </div>
    )
}

export default SwapMain


